import React from 'react';
import './Text.scss';

const Text = function ({ datatestid, children, className }) {
  const finalClassName = className ? className : '';
  return (
    <div className={`basicTextContainer`}>
      <div
        data-testid={datatestid ? `${datatestid}-basicText` : null}
        className={`basicText ${finalClassName}`}
      >
        {children}
      </div>
    </div>
  );
};

export default Text;
